import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Company } from 'src/models/company.model';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  baseUrl = environment.apiUrl + 'Company/';
  baseUrl2 = environment.apiUrl + 'Account/';
  baseUrl3 = environment.apiUrl + 'User/';
  baseUrl4 = environment.apiUrl + 'CompanyUser/';

  constructor(
    private http: HttpClient,
    private router: Router,
    private _location: Location
  ) {}

  getAllCompanies(
    page: number,
    pageSize: number,
    name: string
  ): Observable<HttpResponse<Company[]>> {
    return this.http.get<Company[]>(
      this.baseUrl + `GetAll/${page}/${pageSize}?name=${name}`,
      {
        observe: 'response',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('originalToken')}`,
        },
      }
    );
  }

  getByUser(): Observable<HttpResponse<Company[]>> {
    return this.http.get<Company[]>(
      this.baseUrl + `GetByUser`,
      {
        observe: 'response',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );
  }

  getOnlyAllCompanies(
    page: number,
    pageSize: number
  ): Observable<HttpResponse<Company[]>> {
    return this.http.get<Company[]>(
      this.baseUrl + `GetAll/${page}/${pageSize}`,
      {
        observe: 'response',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('originalToken')}`,
        },
      }
    );
  }

  getCompanyById(idCompany: number): Observable<HttpResponse<Company[]>> {
    return this.http.get<Company[]>(this.baseUrl + idCompany, {
      observe: 'response',
    });
  }

  saveCompany(id: Number, data): Observable<any> {
    return this.http.post(this.baseUrl + `update/${id}`, data);
  }

  getUserListByCompany(
    companyId: number,
    page: number,
    pageSize: number
  ): Observable<HttpResponse<any>> {
    return this.http.get<any>(
      this.baseUrl3 + `getByCompany/${companyId}/${page}/${pageSize}`,
      { observe: 'response' }
    );
  }

  getPendingUsersList(
    page: number,
    pageSize: number
  ): Observable<HttpResponse<any>> {
    return this.http.get<any>(
      this.baseUrl3 + `getPending/${page}/${pageSize}`,
      { observe: 'response' }
    );
  }

  getDepartments(): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + `departments`, {
      observe: 'response',
    });
  }

  getDepartmentsByCompany(idCompany): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + `departments/${idCompany}`, {
      observe: 'response',
    });
  }

  getRoles(): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl3 + `userRolesList`, {
      observe: 'response',
    });
  }

  getCompanyLogo(): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + 'getLogo', {
      observe: 'response',
    });
  }

  createCompany(data): Observable<any> {
    var options = { content: data };
    return this.http.post(this.baseUrl + `create`, data);
  }

  getByCompanyCount(id): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl3 + `getByCompanyCount/${id}`, {
      observe: 'response',
    });
  }

  getLangs(): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + 'Languages', {
      observe: 'response',
    });
  }

  importCsv(file, companyId): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post(
      this.baseUrl4 + `importCompanyUsers?companyId=${companyId}`,
      formData
    );
  }

  getDataTypes(companyIds): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + `GetSensitiveInformationTypes?companyIds=${companyIds}`, {
      observe: 'response',
    });
  }

  setDataTypes(ids, companyId): Observable<any> {
    const data = {
      companyId: companyId,
      sensitiveInformationTypeIds: ids
    }
    return this.http.post(
      this.baseUrl + `SetSensitiveInformationTypes`,
      data
    );
  }

  downloadDepartmentsTemplate(companyId: number): Observable<Blob> {
    return this.http.get(this.baseUrl + `departmentsTemplate/${companyId}`, { responseType: 'blob' });
  }
}
